import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Categories } from './sections/categories';
import { AllApps } from './sections/all-apps';
import { Settings } from './sections/settings';
export const Home = ({ isTg }) => (_jsxs("div", { children: [_jsx(Categories, { isTg: isTg }), _jsx(AllApps, { isTg: isTg }), _jsx(Settings, {})] }));
